import { render, staticRenderFns } from "./SuppressionList.vue?vue&type=template&id=56b91234&"
import script from "./SuppressionList.vue?vue&type=script&lang=js&"
export * from "./SuppressionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports